export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
